module.exports = "/images/circle-marker-car-2.png?4c73ee5e001165369c918170716c7d90";